/*
 * Mega menu met zijbalk - desktopgedrag.
 * Hoort bij snippets/header-menu-mega-sidebar.liquid en assets/header-mega-sidebar.css.
 *
 * - Hover op een zijbalk-link wisselt het paneel in het hoofdvlak.
 * - Hover op een kolom-link wisselt de productkaarten naar die collectie.
 * - Productkaarten worden lazy geladen via /collections/<handle>?section_id=mega-menu-products
 *   en per collectie gecachet.
 * - De pijltjes scrollen de kaartenrij één kaart verder.
 */
(function () {
  'use strict';

  var nav = document.getElementById('nav-bar');
  if (!nav || !nav.classList.contains('mega_sidebar')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var pending = {};
  var HOVER_DELAY = 120;

  function fetchProducts(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    if (pending[handle]) return pending[handle];
    var url = root + 'collections/' + encodeURIComponent(handle) + '?section_id=mega-menu-products';
    pending[handle] = fetch(url)
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        cache[handle] = section ? section.innerHTML : '';
        delete pending[handle];
        return cache[handle];
      })
      .catch(function () {
        delete pending[handle];
        return '';
      });
    return pending[handle];
  }

  // Pijltjes alleen tonen als de kaartenrij daadwerkelijk kan scrollen
  function updateArrows(container) {
    var track = container.querySelector('.ms-cards');
    if (!track) return;
    container.classList.toggle('ms-no-scroll', track.scrollWidth <= track.clientWidth + 1);
  }

  // Placeholder-kaarten: dezelfde opbouw als de echte, zodat het paneel niet verspringt
  function skeleton(container) {
    var visible = parseInt(getComputedStyle(container).getPropertyValue('--ms-visible'), 10) || 4;
    var cards = '';
    for (var i = 0; i < visible; i++) {
      cards +=
        '<li class="ms-card"><span class="ms-card-img"></span><span class="ms-card-body">' +
        '<span class="ms-card-title">&nbsp;</span><span class="ms-card-price">&nbsp;</span>' +
        '</span></li>';
    }
    return (
      '<div class="ms-products-head"><p class="ms-products-title"><span class="ms-skeleton-title">&nbsp;</span></p></div>' +
      '<ul class="ms-cards ms-cards-skeleton" aria-hidden="true">' + cards + '</ul>'
    );
  }

  function renderProducts(container) {
    var handle = container.dataset.msCollection;
    if (!handle || container.dataset.msRendered === handle) {
      updateArrows(container);
      return;
    }
    // Lege collectie: niets tonen, ook geen placeholder
    if (container.dataset.msCount === '0') {
      container.innerHTML = '';
      container.dataset.msRendered = handle;
      return;
    }
    if (!container.querySelector('.ms-cards') || container.dataset.msRendered) {
      container.innerHTML = skeleton(container);
    }
    fetchProducts(handle).then(function (html) {
      if (container.dataset.msCollection !== handle) return; // intussen gewisseld
      container.innerHTML = html;
      container.dataset.msRendered = handle;
      container.classList.remove('ms-loading');
      var title = container.querySelector('.ms-products-title a');
      if (title) {
        if (container.dataset.msTitle) title.textContent = container.dataset.msTitle;
        if (container.dataset.msUrl) title.setAttribute('href', container.dataset.msUrl);
      }
      updateArrows(container);
    });
  }

  function setActive(list, activeItem) {
    Array.prototype.forEach.call(list.children, function (item) {
      item.classList.toggle('ms-active', item === activeItem);
    });
  }

  function hoverIntent(el, callback) {
    var timer;
    el.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      timer = setTimeout(callback, HOVER_DELAY);
    });
    el.addEventListener('mouseleave', function () {
      clearTimeout(timer);
    });
    el.addEventListener('focus', callback);
  }

  Array.prototype.forEach.call(nav.querySelectorAll(':scope > ul > li.ms-mega'), function (item) {
    // Zijbalk: wissel paneel
    Array.prototype.forEach.call(item.querySelectorAll('.ms-sidebar-links > li > a'), function (link) {
      var li = link.parentElement;
      hoverIntent(link, function () {
        setActive(li.parentElement, li);
        var paneId = link.dataset.msPane;
        var activePane = null;
        Array.prototype.forEach.call(item.querySelectorAll('.ms-pane'), function (pane) {
          var isActive = pane.dataset.msPaneId === paneId;
          pane.classList.toggle('ms-active', isActive);
          if (isActive) activePane = pane;
        });
        var products = activePane && activePane.querySelector('[data-ms-products]');
        if (products) renderProducts(products);
      });
    });

    // Kolommen: wissel productkaarten
    Array.prototype.forEach.call(item.querySelectorAll('.ms-col > li > a[data-ms-collection]'), function (link) {
      var li = link.parentElement;
      hoverIntent(link, function () {
        var pane = link.closest('.ms-pane');
        if (!pane) return;
        Array.prototype.forEach.call(pane.querySelectorAll('.ms-col > li'), function (colItem) {
          colItem.classList.toggle('ms-active', colItem === li);
        });
        var products = pane.querySelector('[data-ms-products]');
        if (!products) return;
        products.dataset.msCollection = link.dataset.msCollection;
        products.dataset.msTitle = link.dataset.msTitle || '';
        products.dataset.msUrl = link.dataset.msUrl || '';
        products.dataset.msCount = link.dataset.msCount || '';
        renderProducts(products);
      });
    });

    // Top-item: zorg dat het zichtbare paneel producten heeft
    item.addEventListener('mouseenter', function () {
      var products = item.querySelector('.ms-pane.ms-active [data-ms-products]');
      if (products) renderProducts(products);
    });
  });

  // Open/dicht animeert (CSS), maar direct van het ene menu naar het andere is instant.
  // Een paneel telt nog als open tot de sluit-animatie (400ms) voorbij is.
  var CLOSE_MS = 400;
  var openItem = null;
  var closeTimer = null;
  Array.prototype.forEach.call(nav.querySelectorAll(':scope > ul > li'), function (li) {
    if (!li.querySelector(':scope > [data-ms-panel]')) return;
    li.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (openItem && openItem !== li) {
        nav.classList.add('ms-instant');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { nav.classList.remove('ms-instant'); });
        });
      }
      openItem = li;
    });
    li.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openItem === li) openItem = null;
      }, CLOSE_MS);
    });
  });

  // Pijltjes
  nav.addEventListener('click', function (event) {
    var button = event.target.closest('.ms-arrow');
    if (!button || !nav.contains(button)) return;
    event.preventDefault();
    var block = button.closest('.ms-products');
    var track = block && block.querySelector('.ms-cards');
    if (!track) return;
    var card = track.querySelector('.ms-card');
    var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth / 2;
    track.scrollBy({ left: button.classList.contains('ms-arrow-next') ? step : -step, behavior: 'smooth' });
  });
})();
